import { useState } from "react";
import { toast } from "sonner";
import { Send } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

const DESTINATIONS = [
  { key: "benin", label: "Bénin — Couvent Dah Ayidji (22 jours)" },
  { key: "haiti", label: "Haïti — Lakou Impérial Savann Karé" },
  { key: "senegal", label: "Sénégal — Voyages initiatiques et lieux de mémoire" },
];

export const RetreatForm = () => {
  const { user } = useAuth();
  const [form, setForm] = useState({ name: user?.name || "", email: user?.email || "", phone: "", destination: "", period: "", message: "" });
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.destination) { toast.error("Choisissez une destination"); return; }
    setBusy(true);
    try {
      await api.post("/retreats/register", form);
      setSent(true);
      toast.success("Pré-inscription envoyée — la Fondation vous recontactera");
    } catch {
      toast.error("Erreur — réessayez");
    } finally {
      setBusy(false);
    }
  };

  const input = "w-full bg-input border border-primary/20 rounded-lg px-4 py-3 text-sm focus:ring-2 focus:ring-primary focus:outline-none";

  if (sent) {
    return (
      <div className="border border-primary/30 bg-primary/5 rounded-lg p-10 text-center" data-testid="retreat-form-success">
        <h3 className="font-serif-display text-2xl text-primary">Mèsi anpil ! Pré-inscription reçue</h3>
        <p className="text-sm text-foreground/70 mt-3">La Fondation Sèlide Kouzen-Kouzin vous recontactera à l'adresse indiquée pour les détails, dates et modalités.</p>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="bg-card border border-primary/15 rounded-lg p-8" data-testid="retreat-form">
      <h2 className="text-2xl font-serif-display">Pré-inscription aux retraites</h2>
      <p className="text-sm text-foreground/65 mt-2">Remplissez ce formulaire — la Fondation reçoit votre demande par email et vous recontacte.</p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
        <input required placeholder="Nom complet" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className={input} data-testid="retreat-name-input" />
        <input required type="email" placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className={input} data-testid="retreat-email-input" />
        <input placeholder="Téléphone / WhatsApp (optionnel)" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className={input} data-testid="retreat-phone-input" />
        <select required value={form.destination} onChange={(e) => setForm({ ...form, destination: e.target.value })} className={input} data-testid="retreat-destination-select">
          <option value="">— Destination —</option>
          {DESTINATIONS.map((d) => <option key={d.key} value={d.key}>{d.label}</option>)}
        </select>
        <input placeholder="Période souhaitée (ex. hiver 2027)" value={form.period} onChange={(e) => setForm({ ...form, period: e.target.value })} className={`${input} md:col-span-2`} data-testid="retreat-period-input" />
        <textarea rows={3} placeholder="Message, questions, motivations… (optionnel)" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className={`${input} md:col-span-2`} data-testid="retreat-message-input" />
      </div>
      <button type="submit" disabled={busy}
        className="mt-6 inline-flex items-center gap-2 px-7 py-3 rounded-full bg-primary text-primary-foreground text-sm font-medium hover:bg-[#16528A] transition-colors duration-200 disabled:opacity-50"
        data-testid="retreat-submit-btn">
        <Send size={15} /> {busy ? "Envoi…" : "Envoyer ma pré-inscription"}
      </button>
    </form>
  );
};
